import React, { useEffect } from 'react';
import validator from 'validator';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import {
    TextField,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    Box,
} from '@mui/material';
import { createState, useState, Downgraded } from '@hookstate/core';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import Helper from '../../utility/helper';

const initalState = createState({
    id: -1,
    firstName: '',
    lastName: '',
    checkInDate: new Date(),
    checkOutDate: new Date(),
    roomAndTaxData: [],
    roomAndTaxID: '',
    roomTypeID: '',
    roomTypeData: [],
    roomType: '',
    roomAndTax: '',
});
const AddGuest = (props) => {
    const [firstNameErr, setFirstNameErr] = React.useState('');
    const [lastNameErr, setLastNameErr] = React.useState('');
    const guestState = createState(initalState);

    const state = useState(guestState);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });

    const handleCheckInDateTime = (event) => {
        state.checkInDate.set(event);
    };
    const handleCheckOutDateTime = (event) => {
        state.checkOutDate.set(event);
    };

    const handleChangeRoomType = (event) => {
        state.roomTypeID.set(event.target.value);
    };

    const handleChangeRoomTax = (event) => {
        state.roomAndTaxID.set(event.target.value);
    };

    const validateFirstName = () => {
        let value = state.firstName.get().trim();
        if (value == '') {
            setFirstNameErr('Please Enter  First Name');
            return { flag: 'false', messages: 'Please Enter  First Name' };
        } else {
            if (validator.isAlpha(value)) {
                setFirstNameErr('');
                return true;
            } else setFirstNameErr('Please Enter Valid First Name');
            return { flag: 'false', messages: 'Please Enter valid First Name' };
        }
    };
    const validateLastName = () => {
        let value = state.lastName.get().trim();
        if (value == '') {
            setLastNameErr('Please Enter Last Name');
            return { flag: 'false', messages: 'Please Enter Last Name' };
        }
        if (validator.isAlpha(value)) {
            setLastNameErr('');
            return true;
        } else setLastNameErr('Please Enter Valid Last Name');
        return { flag: 'false', messages: 'Please Enter Valid Last Name' };
    };

    useEffect(() => {
        // state.set(initalState);
        if (props.data != null) {
            state.set({
                id: props.data.id,
                firstName: props.data.firstName,
                lastName: props.data.lastName,
                checkInDate: props.data.checkInDate,
                checkOutDate: props.data.checkOutDate,
                roomTypeID: props.data.roomTypeID,
                roomTypeData: props.roomTypeData ? props.roomTypeData : [],
                roomAndTaxData: props.roomTaxData ? props.roomTaxData : [],
                roomAndTaxID: props.data.roomAndTaxID,
            });
        } else {
            state.set({
                id: -1,
                firstName: '',
                lastName: '',
                checkInDate: new Date(),
                checkOutDate: new Date(),
                roomTypeData: props.roomTypeData ? props.roomTypeData : [],
                roomTypeID: 1,
                roomAndTaxData: props.roomTaxData ? props.roomTaxData : [],
                roomAndTaxID: 1,
            });
        }
    }, [props]);

    const renderDialogContent = () => {
        return (
            <Box>
                <Box
                    sx={{
                        padding: 1,
                        '& .MuiFormControl-root': { width: '100%' },
                    }}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: {
                                xs: 'column',
                                md: 'row',
                            },
                            padding: 0,
                            flex: 1,
                            marginTop: 1,
                        }}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                flex: 0.5,
                                alignItems: 'center',
                                padding: 1,
                            }}>
                            <TextField
                                size="small"
                                required
                                id="outlined-required"
                                label="First Name"
                                autoComplete="off"
                                value={state.firstName.attach(Downgraded).get()}
                                onChange={(event) => {
                                    state.firstName.set(event.target.value);
                                }}
                                error={firstNameErr.length > 0 ? true : false}
                                helperText={
                                    firstNameErr.length > 0 ? firstNameErr : ''
                                }
                                inputProps={{ maxLength: 50 }}
                            />
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                flex: 0.5,
                                alignItems: 'center',
                                padding: 1,
                            }}>
                            <TextField
                                size="small"
                                required
                                id="outlined-required"
                                label="Last Name"
                                autoComplete="off"
                                value={state.lastName.attach(Downgraded).get()}
                                onChange={(event) => {
                                    state.lastName.set(event.target.value);
                                }}
                                error={lastNameErr.length > 0 ? true : false}
                                helperText={
                                    lastNameErr.length > 0 ? lastNameErr : ''
                                }
                                inputProps={{ maxLength: 50 }}
                            />
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: {
                                xs: 'column',
                                md: 'row',
                            },
                            padding: 0,
                            flex: 1,
                            marginTop: 1,
                        }}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                flex: 0.5,
                                alignItems: 'center',
                                padding: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    flex: 1,
                                    alignItems: 'center',
                                }}>
                                <FormControl fullWidth={false} size="small">
                                    <InputLabel id="demo-simple-select-label">
                                        Room Type
                                    </InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={state.roomTypeID
                                            .attach(Downgraded)
                                            .get()}
                                        label="Select Room Type"
                                        onChange={handleChangeRoomType}>
                                        {state.roomTypeData.get() &&
                                            state.roomTypeData
                                                .get(Downgraded)
                                                .map((option) => (
                                                    <MenuItem
                                                        key={option.value}
                                                        value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                flex: 0.5,
                                alignItems: 'center',
                                marginTop: { xs: 2, md: 0 },
                                padding: 1,
                            }}>
                            <FormControl fullWidth={false} size="small">
                                <InputLabel id="demo-simple-select-label">
                                    Room and Tax
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={state.roomAndTaxID
                                        .attach(Downgraded)
                                        .get()}
                                    label="Hotel Room Needed?"
                                    onChange={handleChangeRoomTax}>
                                    {state.roomAndTaxData.get() &&
                                        state.roomAndTaxData
                                            .get(Downgraded)
                                            .map((option) => (
                                                <MenuItem
                                                    key={option.value}
                                                    name={option.label}
                                                    value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                </Select>
                            </FormControl>
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: {
                                xs: 'column',
                                md: 'row',
                            },
                            padding: 0,
                            flex: 1,
                            marginTop: 1,
                        }}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                flex: 0.5,
                                padding: 1,
                            }}>
                            <MUIDatePicker
                                label="Check In"
                                value={state.checkInDate
                                    .attach(Downgraded)
                                    .get()}
                                error={state.dateTimeErrorMsg.get()}
                                setValue={handleCheckInDateTime}
                            />
                            {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    label="Check In"
                                    value={state.checkInDate
                                        .attach(Downgraded)
                                        .get()}
                                    inputProps={{ readOnly: true }}
                                    minDate={new Date()}
                                    onChange={(newValue) =>
                                        handleCheckInDateTime(newValue)
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            size="small"
                                            helperText={state.dateTimeErrorMsg.get()}
                                            autoComplete="off"
                                            onKeyDown={(e) =>
                                                e.preventDefault()
                                            }
                                            error={
                                                state.dateTimeErrorMsg.get()
                                                    ? state.dateTimeErrorMsg.get()
                                                          .length > 0
                                                        ? true
                                                        : false
                                                    : false
                                            }
                                        />
                                    )}
                                />
                            </LocalizationProvider> */}
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                flex: 0.5,
                                padding: 1,
                            }}>
                            <MUIDatePicker
                                label="Check Out"
                                value={state.checkOutDate
                                    .attach(Downgraded)
                                    .get()}
                                error={state.dateTimeErrorMsg.get()}
                                setValue={handleCheckOutDateTime}
                            />
                            {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    label="Check Out"
                                    value={state.checkOutDate
                                        .attach(Downgraded)
                                        .get()}
                                    inputProps={{ readOnly: true }}
                                    minDate={new Date()}
                                    onChange={(newValue) =>
                                        handleCheckOutDateTime(newValue)
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            size="small"
                                            helperText={state.dateTimeErrorMsg.get()}
                                            autoComplete="off"
                                            onKeyDown={(e) =>
                                                e.preventDefault()
                                            }
                                            error={
                                                state.dateTimeErrorMsg.get()
                                                    ? state.dateTimeErrorMsg.get()
                                                          .length > 0
                                                        ? true
                                                        : false
                                                    : false
                                            }
                                        />
                                    )}
                                />
                            </LocalizationProvider> */}
                        </Box>
                    </Box>
                </Box>
                {snackBarProps.openSnack && (
                    <CustomizedSnackbars
                        {...snackBarProps}
                        onClose={() =>
                            setSnackBarProps({
                                ...snackBarProps,
                                openSnack: false,
                            })
                        }></CustomizedSnackbars>
                )}
            </Box>
        );
    };

    const handleClick = () => {
        const fName = validateFirstName();
        const lName = validateLastName();

        if (fName.flag === 'false') {
            // setSnackBarProps({
            //     ...snackBarProps,
            //     openSnack: true,
            //     variant: 'error',
            //     message: fName.messages,
            // });
            return;
        }
        if (lName.flag === 'false') {
            // setSnackBarProps({
            //     ...snackBarProps,
            //     openSnack: true,
            //     variant: 'error',
            //     message: lName.messages,
            // });
            return;
        }
        const dateCheck = Helper.checkSameOrAfterDate(
            new Date(state.checkInDate.get()),
            new Date(state.checkOutDate.get())
        );

        if (!dateCheck) {
            setSnackBarProps({
                openSnack: true,
                variant: 'error',
                message:
                    'Check out date should be greater than or equal to Check in date',
            });

            return false;
        }

        props.handleAction(
            state.firstName.attach(Downgraded).get(),
            state.lastName.attach(Downgraded).get(),
            state.roomTypeID.attach(Downgraded).get(),
            state.roomAndTaxID.attach(Downgraded).get(),
            state.checkInDate.attach(Downgraded).get(),
            state.checkOutDate.attach(Downgraded).get(),
            state.roomTypeData
                .get()
                .find(
                    (item) =>
                        item.value === state.roomTypeID.attach(Downgraded).get()
                ).label,
            state.roomAndTaxData
                .get()
                .find(
                    (item) =>
                        item.value ===
                        state.roomAndTaxID.attach(Downgraded).get()
                ).label,
            state.id.get()
        );
    };

    const renderDialogActions = () => {
        return (
            <ButtonContainer
                handleClick={handleClick}
                handleCancel={props.handleClose}
                buttonText={props.data != null ? 'Update' : 'Create'}
            />
        );
    };

    return (
        <CustomDialog
            title={props.title}
            handleClose={props.handleClose}
            open={props.open}
            fullWidth={true}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
        />
    );
};

export default AddGuest;
